var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0", staticStyle: { height: "100%" } },
    [
      _c(
        "v-card",
        {
          staticClass: "pull-up",
          staticStyle: { height: "100%", "border-top": "4px solid #fa646e" },
          attrs: { "fill-height": "", color: "#fff" }
        },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex justify-center py-0 my-0",
              attrs: { lg: "12", md: "12", sm: "12", xs: "12" }
            },
            [
              _c(
                "v-row",
                {
                  class: {
                    "mx-auto": this.$vuetify.breakpoint.mdAndUp,
                    "d-flex justify-center mt-2": true
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-0 pt-2",
                      attrs: { text: "", small: "", color: "transparent" },
                      on: {
                        click: function($event) {
                          return _vm.changeDataCenter(_vm.DATA_CENTER_CCS_ID)
                        }
                      }
                    },
                    [
                      _c(
                        "p",
                        {
                          style:
                            _vm.dataCenterSelected === _vm.DATA_CENTER_CCS_ID
                              ? "color: #00AAB8"
                              : "color: #bbbcc4"
                        },
                        [_vm._v(" " + _vm._s(_vm.DATA_CENTER_CCS_NAME) + " ")]
                      )
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "pt-2 px-0",
                      attrs: { text: "", small: "", color: "transparent" },
                      on: {
                        click: function($event) {
                          return _vm.changeDataCenter(_vm.DATA_CENTER_VAL_ID)
                        }
                      }
                    },
                    [
                      _c(
                        "p",
                        {
                          style:
                            _vm.dataCenterSelected === _vm.DATA_CENTER_VAL_ID
                              ? "color: #2B953E"
                              : "color: #bbbcc4"
                        },
                        [_vm._v(" " + _vm._s(_vm.DATA_CENTER_VAL_NAME) + " ")]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "align-end text-center py-0 my-0",
              attrs: { cols: "12", md: "12" }
            },
            [
              _c(
                "h1",
                {
                  staticClass: "font-weight-light",
                  style:
                    _vm.dataCenterSelected === _vm.DATA_CENTER_VAL_ID
                      ? "font-size: 80px; color: #464855;"
                      : "font-size: 80px; color: #464855;"
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.incidentItem ? _vm.incidentItem.total : "0") +
                      " "
                  )
                ]
              ),
              _c(
                "v-card-subtitle",
                {
                  staticClass:
                    "overline d-flex justify-center align-end pt-0 mt-0 mb-1 pb-1",
                  staticStyle: { color: "#464855" }
                },
                [
                  _c(
                    "h4",
                    {
                      staticClass: "pa-0",
                      staticStyle: { "word-break": "break-word" }
                    },
                    [
                      _c("b", [
                        _vm._v("Interrupciones trimestrales de CORPOELEC")
                      ])
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }